/**
 * 品牌全案案例相关 API（对接若依 /studies/brandCase）
 */
import request from '@/utils/request'

/**
 * 获取品牌全案案例列表（分页）
 * @param {Object} params - 查询参数 { pageNum, pageSize, title, description, link, status }
 * @returns {Promise} 若依格式 { code, msg, total, rows }
 */
export function getBrandCasesList(params) {
  return request({
    url: 'studies/brandCase/list',
    method: 'get',
    params
  })
}

/**
 * 获取品牌全案案例详情
 * @param {Number|String} id - 案例 ID
 * @returns {Promise} 若依格式 { code, msg, data }
 */
export function getBrandCaseDetail(id) {
  return request({
    url: `studies/brandCase/${id}`,
    method: 'get'
  })
}
